import { useCreateEmailIntegration } from 'entities/campaign';
import { useModalsActions } from 'shared/ui/SideModal';

import { EmailsEditor } from './EmailsEditor';
import { ManageEmailsModal } from './ManageEmailsModal';

export interface EmailNotificationsEditorProps {
  campaignId: number;
  emails: string[];
}

export function CreateEmailsModal({ campaignId, emails }: EmailNotificationsEditorProps) {
  const editEmailsQuery = useCreateEmailIntegration(campaignId);
  const { closeAllBesidesFirst, open } = useModalsActions();

  const handleSubmit = (emails: string[]) => {
    editEmailsQuery.mutate(
      {
        urlParams: { campaignId },
        payload: { emails },
      },
      {
        onSuccess: () => {
          if (!emails.length) {
            closeAllBesidesFirst();

            return;
          }

          open(
            <ManageEmailsModal
              skipPrevModal
              campaignId={campaignId}
              emails={emails}
            />
          );
        },
      }
    );
  };

  return (
    <EmailsEditor
      emails={emails}
      isLoading={editEmailsQuery.isLoading}
      error={editEmailsQuery.error}
      submit={handleSubmit}
    />
  );
}
